import React from "react";
import Button from "./Button";

interface CTACardProps {
  title: string | React.ReactNode;
  buttonText: string;
  onButtonClick: () => void;
  className?: string;
  width?: "sm" | "md" | "lg" | "full";
  imageSrc?: string;
  imageAlt?: string;
  disabled?: boolean;
}

const CTACard = ({
  title,
  buttonText,
  onButtonClick,
  className = "",
  width = "full",
  imageSrc,
  imageAlt = "Profile image",
  disabled = false,
}: CTACardProps) => {
  const widthClasses = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    full: "w-full",
  };

  return (
    <div
      className={`relative bg-white border-2 border-electrum rounded-2xl p-8 text-center shadow-lg max-w-sm ${imageSrc ? "mt-28" : ""} ${widthClasses[width]} ${className}`}
    >
      {/* Circular image that extends above the card */}
      {imageSrc && (
        <div className="absolute -top-28 left-1/2 transform -translate-x-1/2">
          <div className="w-56 h-56 rounded-full overflow-hidden">
            <img
              src={imageSrc}
              alt={imageAlt}
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      )}

      {/* Content with top padding if image is present */}
      <div className={imageSrc ? "pt-28" : ""}>
        <h3 className="text-xl font-bold text-gray-800 mb-6">{title}</h3>
        <Button
          variant="primary"
          className="w-full py-3 text-base"
          onClick={onButtonClick}
          disabled={disabled}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

export default CTACard;
